var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#484888",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M811-77q-142 0-274.5-62t-235-164.5Q199-406 137-539T75-814q0-32 20.5-53t53.5-21h175q38 0 61.5 18t30.5 52l27 130q5 30-1 52t-26 39l-106 94q32 50 79.5 98t98.5 81l108-102q19-19 41.5-25.5t50.5.5l127 29q35 9 52.5 30.5T885-336v184q0 33-20.5 54T811-77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6d55badb4fa66ea68c585dea20ef5618.svg";
export { ForwardRef as ReactComponent };